import _ from 'lodash';
import { GetStaticPaths, GetStaticProps } from 'next';
import {
  fetchReferences,
  fetchRelatedReferencesDetailsData,
} from 'src/modules/professionals/references';
import {
  ProfessionalsReferencesDetailsPage,
  fetchReferencesDetailsData,
} from 'src/modules/professionals';
import { ReferenceEntity } from 'src/modules/professionals';
import fs from 'fs';
import filterPathsListWithOutputChannel from 'src/utils/filterPathsListWithOutputChannel';

export const getStaticPaths: GetStaticPaths = async () => {
  const references = await fetchReferences();

  const getPaths = (references: ReferenceEntity[], locale: 'en' | 'de') => {
    return _.chain(references)
      .map(({ article }) => {
        if (!article?.slug) {
          console.log(
            'professionals/projects/[slug] skip article without slug',
            article?.id,
            article?.hero?.title,
            article?.hero?.label,
            article?.designer?.name
          );
          return null;
        }

        return {
          params: { slug: article.slug },
          locale,
        };
      })
      .compact()
      .value();
  };

  const pathsEn = getPaths(references, 'en');
  const pathsDe = getPaths(references, 'de');

  const pathsList = filterPathsListWithOutputChannel(
    _.map([...pathsEn, ...pathsDe], (p) => `${p.locale}/professionals/projects/${p.params.slug}`)
  );

  fs.writeFileSync(
    './public/data/paths/professionals_projects_slug.json',
    JSON.stringify(pathsList, null, 2)
  );

  return { paths: [], fallback: true };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const slug = params?.slug as string;
  const data = await fetchReferencesDetailsData(slug as string);
  const article = data?.articles?.[0] || null;

  const relatedReferencesData = await fetchRelatedReferencesDetailsData(
    article.reference.reference_category.id,
    article.id
  );
  const relatedReferences = relatedReferencesData?.references || [];

  return { props: { referencesPage: { article, relatedReferences } } };
};

export default ProfessionalsReferencesDetailsPage;
